import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Modal.css';

const ModalFooter = ({
  className,
  children,
  ...otherProps
}) => {
  const classes = classNames(
    'actions',
    'ng-ui-modal-footer',
    className
  );

  return (
    <div
      className={classes}
      {...otherProps}
    >
      {children}
    </div>
  );
};

ModalFooter.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
    PropTypes.node,
  ]),
};

ModalFooter.displayName = 'Modal.Footer';

export default ModalFooter;